// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"u2-z"};